import { analytics } from "@/analytics/ga";
import type { RootStore } from ".";

export class Ga4Store {
  rootStore: RootStore;

  get activeProvinceId() {
    return this.rootStore.activeProvinceId;
  }

  get orderProducts() {
    return this.rootStore.orderProducts;
  }

  get orderData() {
    return this.rootStore.orderData;
  }

  get orderTotal() {
    return this.rootStore.orderTotals.total;
  }

  get items() {
    return this.orderProducts.map((product, index) => ({
      name: product.name,
      price: product.price,
      quantity: product.quantity,
      index,
    }));
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  clickExternalLink = (url: string) => {
    analytics.sendEvent("click_external_link", url);
  };

  selectRegion = (provinceId: string) =>
    analytics.sendEvent("select_region", { province: provinceId });

  viewItems = () =>
    analytics.sendEvent("view_item", {
      currency: "CAD",
      province: this.activeProvinceId,
      items: this.orderProducts.map((product, index) => ({
        name: product.name,
        price: product.price,
        quantity: 1,
        index,
      })),
    });

  addToCart = () =>
    analytics.sendEvent("add_to_cart", {
      currency: "CAD",
      province: this.activeProvinceId,
      value: this.orderData.total,
      items: this.items,
    });

  beginCheckout = () => {
    analytics.sendEvent("begin_checkout", {
      currency: "CAD",
      province: this.activeProvinceId,
      value: this.orderData.total,
      items: this.items,
    });
  };

  addShippingInfo = () =>
    analytics.sendEvent("add_shipping_info", {
      province: this.activeProvinceId,
    });

  purchase = (orderId: number | string) =>
    analytics.sendEvent("purchase", {
      transaction_id: orderId,
      currency: "CAD",
      province: this.activeProvinceId,
      value: this.orderTotal,
      shipping: this.orderData.shippingCost,
      items: this.items,
    });
}
